import { Component, Prop, Vue } from "vue-property-decorator";
import StackedBar from "./StackedBarChart/StackedBarChart.vue";
import BarChart from "./BarChart/BarChart.vue";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import StackedPolarChart from "./StackedPolarChart/StackedPolarChart.vue";
import StackedRadialChart from "./StackedRadialChart/StackedRadialChart.vue";
import PieChart from "./PieChart/PieChart.vue";
import DoughnutChart from "./DoughnutChart/DoughnutChart.vue";
import StackedLineChart from "./StackedLineChart/StackedLineChart.vue";
import LineChart from "./LineChart/LineChart.vue";
import StackedBarChart from "./StackedBarChart/StackedBarChart.vue";

@Component({
  name: "Charts",
  components: {
    StackedBar,
    BarChart,
    StackedBarChart,
    StackedPolarChart,
    StackedRadialChart,
    PieChart,
    DoughnutChart,
    StackedLineChart,
    LineChart
  }
})
export default class Charts extends Vue {
  @Prop() propertiesToChart!: {
    indexSectionOfDashboard: number;
    indexCollectionFilter: number;
    groupBy: DynamicSelectData[];
    chartType: string;
    isHorizontal: boolean;
    chartColor: string;
  };

  width = 500;
  height = 400;
  isResizing = false;
  startX = 0;
  startY = 0;
  startWidth = 0;
  startHeight = 0;

  private chartMap: Record<string, any> = {
    bar: BarChart,
    "horizontal-bar": BarChart,
    pie: PieChart,
    doughnut: DoughnutChart,
    line: LineChart,
    stackedLine: StackedLineChart,
    stackedColumn: StackedBarChart,
    "horizontal-stackedColumn": StackedBarChart,
    stackedPolar: StackedPolarChart,
    stackedRadial: StackedRadialChart
  };

  get chartComponent() {
    return this.chartMap[this.propertiesToChart.chartType] || null;
  }
  mounted() {
    window.addEventListener("mouseleave", this.stopResize);
  }
  beforeDestroy() {
    window.removeEventListener("mouseleave", this.stopResize);
  }

  get boxStyle() {
    return {
      position: "relative",
      width: this.width + "px",
      height: this.height + "px",
      background: "#fff",
      border: "1px solid #aaa",
      borderRadius: "0.9rem",
      userSelect: "none"
    };
  }

  startResize(e: MouseEvent) {
    this.isResizing = true;

    // guardamos posición inicial
    this.startX = e.clientX;
    this.startY = e.clientY;
    this.startWidth = this.width;
    this.startHeight = this.height;

    window.addEventListener("mousemove", this.resize, { capture: true });
    window.addEventListener("mouseup", this.stopResize, { capture: true });
  }

  resize(e: MouseEvent) {
    if (!this.isResizing) return;

    // diferencia desde el inicio
    const dx = e.clientX - this.startX;
    const dy = e.clientY - this.startY;

    // nuevo tamaño
    this.width = Math.max(100, this.startWidth + dx);
    this.height = Math.max(100, this.startHeight + dy);
  }

  stopResize() {
    this.isResizing = false;
    window.removeEventListener("mousemove", this.resize, true);
    window.removeEventListener("mouseup", this.stopResize, true);
  }
}
